import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom"
import { createStore } from "redux"
import { Provider } from "react-redux"
import reducer from "./store/reducer"
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const store = createStore(reducer)

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
)
ReactDOM.render(app, document.getElementById('root')
);
reportWebVitals();
